<template>
  <div>
    <v-col>
      <s-crud
        add
        edit
        height="auto"
        :filter="filter"
        remove
        @doubleClick="dobleClick"
        title="Áreas"
        excel
        @save="save($event)"
        :config="config"
        ref="SAreasCrud"
        searchInput
      >
        <template v-slot:filter>
          <v-col>
            <v-row justify="center">
              <v-col lg="3"
                ><s-select-definition
                  clearable
                  v-model="filter.TypeArea"
                  :def="1119"
                  label="Tipo de Área"
                >
                </s-select-definition
              ></v-col>
            </v-row>
          </v-col>
        </template>
        <template v-slot:options>
          <v-tooltip bottom="">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text black @click="openMasiveImport()" small>
                <v-icon>mdi-plus-circle-multiple-outline</v-icon>
              </v-btn>
            </template>
            <span>Registro Masivo</span>
          </v-tooltip>
        </template>
        <template scope="props">
          <v-col>
            <v-row>
              <v-col cols="6" md="3" lg="4" class="s-col-form">
                <s-text v-model="props.item.AreName" label="Nombre de área">
                </s-text>
              </v-col>
              <v-col cols="6" md="3" lg="4" class="s-col-form">
                <s-text
                  v-model="props.item.AreAbbreviation"
                  label="Abreviación"
                >
                </s-text>
              </v-col>
              <v-col cols="12" md="3" lg="4" class="s-col-form">
                <s-select-area
                  clearable
                  :typeArea="props.item.TypeArea"
                  :text="props.item.AreParentName"
                  v-model="props.item.AreParentID"
                  label="Área Superior"
                >
                </s-select-area>
              </v-col>
              <v-col lg="2" class="s-col-form">
                <s-select-area-scire
                  clearable
                  v-model="props.item.IdScire"
                  label="Área SCire"
                  :text="props.item.IdScireName"
                >
                </s-select-area-scire>
              </v-col>
              <v-col lg="2" class="s-col-form"
                ><s-text
                  label="Siglas"
                  v-model="props.item.AreAcronym"
                  :maxlength="4"
                  :showCounter="true"
                  :rules="[
                    //value => !!value || 'aaa',
                    (value) =>
                      (value && value.length <= 4) ||
                      'La Sigla tiene maximo 4 caracteres',
                  ]"
                ></s-text
              ></v-col>
              <v-col class="s-col-form" lg="2">
                <s-select-definition
                  v-model="props.item.TypeArea"
                  label="Tipo de área"
                  :def="1119"
                >
                </s-select-definition>
              </v-col>
              <v-col v-if="props.item.TypeArea === 1" lg="3" class="s-col-form">
                <s-select-position
                  clearable
                  :text="props.item.ManagerName"
                  v-model="props.item.PstManagerID"
                  label="Gerencia"
                >
                </s-select-position>
              </v-col>
              <v-col v-else lg="3" class="s-col-form">
                <s-select-position
                  clearable
                  v-model="props.item.PstBossID"
                  label="Jefatura"
                  :text="props.item.BossName"
                >
                </s-select-position>
              </v-col>
              <v-col class="s-col-form">
                <s-select-position
                  clearable
                  v-model="props.item.PstResponsibleID"
                  label="Responsable de área"
                  :text="props.item.ResponsibleName"
                >
                </s-select-position>
              </v-col>
            </v-row>
          </v-col>
        </template>
      </s-crud>

      <v-dialog
        v-if="showOpenMasiveImport"
        v-model="showOpenMasiveImport"
        persistent
        max-width="1024px"
      >
        <v-container>
          <v-row>
            <v-col>
              <s-toolbar
                no-border
                dark
                label="Áreas - Carga Masiva"
                color="#2955c8"
                close
                @close="showOpenMasiveImport = false"
              >
                <v-btn
                  small
                  color="white"
                  text
                  outlined
                  class="text-none mr-2"
                  @click="downloadTemplate()"
                >
                  <v-icon left small>mdi-download</v-icon>
                  Descargar Formato
                </v-btn>
              </s-toolbar>

              <v-card>
                <v-col>
                  <v-row class="mb-1" align="center" justify="space-between">
                    <v-col cols="auto">
                      <span class="text-caption grey--text text--darken-2">
                        Seleccione el archivo Excel con las columnas requeridas:
                      </span>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn
                        small
                        color="primary"
                        outlined
                        class="text-none"
                        @click="downloadTemplate()"
                      >
                        <v-icon left small>mdi-file-excel</v-icon>
                        Descargar Plantilla (.xlsx)
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <s-import-excel
                        :headers="ExcelHeaders"
                        @loaded="saveMassive($event)"
                      ></s-import-excel>
                    </v-col>
                  </v-row>
                </v-col>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
    </v-col>
    <Loader
      v-if="isLoading"
      :counter="true"
      :item="progressCounter"
      :total="progressTotal"
    />
    <ErrorDialog
      v-model="showErrorDialog"
      :title="'Errores en la carga masiva'"
      :message="'Se encontraron los siguientes errores:'"
      :items="errors"
      :headers="errorHeaders"
    />
  </div>
</template>

<script>
import _sArea from "../../services/General/AreaService.js";
import _sGenericService from "../../services/General/GenericService.js";
import _sDefinition from "../../services/General/DefinitionService.js";
import Loader from "@/components/Layout/Loader.vue";
import ErrorDialog from "@/components/HumanResource/ErrorDialog.vue";
import ExcelJS from "exceljs";

export default {
  name: "Area",
  components: {
    Loader,
    ErrorDialog,
  },
  props: {},
  data: () => ({
    filter: { TypeArea: 0, AreID: 0 },
    config: {
      model: {
        AreID: "ID",
        PstManagerID: "number",
        PstBossID: "number",
        PstResponsibleID: "number",
      },
      service: _sArea,
      headers: [
        { text: "ID", value: "AreID", sortable: false, width: 10 },
        { text: "Área", value: "AreName", sortable: false },
        { text: "Abreviación", value: "AreAbbreviation", sortable: false },
        { text: "Tipo Area", value: "TypeAreName", sortable: false },
        { text: "Area Padre", value: "AreParentName", sortable: false },
        { text: "Siglas", value: "AreAcronym", sortable: false },
        {
          text: "Responsable de Área",
          value: "ResponsibleName",
          sortable: false,
        },
        { text: "Id Scire", value: "IdScire", sortable: false },
      ],
    },
    showOpenMasiveImport: false,
    ExcelHeaders: [
      { column: "ID", value: "AreID", text: "ID" },
      { column: "IDScire", value: "IdScire", text: "IDScire" },
      { column: "Area", value: "AreName", text: "Area" },
      { column: "NombreAbrev", value: "AreAbbreviation", text: "NombreAbrev" },
      { column: "Tipo_Area", value: "TypeAreName", text: "Tipo_Area" },
      { column: "Abreviatura", value: "AreAcronym", text: "Abreviatura" },
      { column: "Gerencia_ID", value: "PstManagerID", text: "Gerencia_ID" },
      { column: "Jefatura_ID", value: "PstBossID", text: "Jefatura_ID" },
      { column: "AreaJefe_ID", value: "AreParentID", text: "AreaJefe_ID" },
      { column: "Responsable_ID", value: "PstResponsibleID", text: "Responsable de area" },
    ],
    isLoading: false,
    progressCounter: 0,
    progressTotal: 0,
    errors: [],
    showErrorDialog: false,
    errorHeaders: [
      { text: "Campo", value: "AreName" },
      { text: "Error", value: "ErrorMsg" },
    ],
  }),
  methods: {
    async save(item) {
      if (!item.AreName || item.AreName.length < 3) {
        this.$fun.alert("Complete Nombre de Área", "warning");
        return;
      }
      if (!item.AreAcronym || item.AreAcronym.length < 2) {
        this.$fun.alert("Complete siglas de Área", "warning");
        return;
      }
      if (item.save) {
        await item.save();
      }
    },
    dobleClick(item) {
      this.$emit("dblClick", item);
    },
    openMasiveImport() {
      this.showOpenMasiveImport = true;
    },
    async downloadTemplate() {
      this.isLoading = true;
      let positions = [];
      let areas = [];
      let typeAreas = [];

      try {
        const [posRes, areaRes, defRes] = await Promise.all([
          this.$http.post("generic/PositionSearch", {}, {
            params: { search: "", requestID: this.$fun.getUserID(), AreID: 0 },
          }).catch(() => ({ data: [] })),
          _sGenericService.searcharea("", 0, this.$fun.getUserID()).catch(() => ({ data: [] })),
          _sDefinition.definitiongroup(1119, 0, this.$fun.getUserID()).catch(() => ({ data: [] })),
        ]);

        positions = posRes?.data || [];
        areas = areaRes?.data || [];
        typeAreas = defRes?.data || [];
      } catch (e) {
        console.warn("No se pudieron cargar los catálogos en su totalidad:", e);
      } finally {
        this.isLoading = false;
      }

      const workbook = new ExcelJS.Workbook();
      workbook.creator = "SunExpert";
      workbook.created = new Date();

      // 1. Hoja principal: Plantilla Areas
      const sheet = workbook.addWorksheet("Plantilla Areas", {
        views: [{ state: "frozen", xSplit: 0, ySplit: 1 }],
      });

      sheet.columns = this.ExcelHeaders.map((h) => ({
        header: h.column,
        key: h.column,
        width: Math.max(h.column.length + 5, 20),
      }));

      const headerRow = sheet.getRow(1);
      headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
      headerRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF2955C8" },
      };
      headerRow.alignment = { horizontal: "center", vertical: "middle" };
      headerRow.height = 25;

      const samplePst1 = positions[0]?.GenID || 15;
      const samplePst2 = positions[1]?.GenID || 10;
      const sampleParentArea = areas[0]?.GenID || 1;

      sheet.addRow({
        ID: "",
        IDScire: "0101",
        Area: "TECNOLOGÍA DE LA INFORMACIÓN",
        NombreAbrev: "SISTEMAS",
        Tipo_Area: "AREA",
        Abreviatura: "TI",
        Gerencia_ID: "",
        Jefatura_ID: samplePst1,
        AreaJefe_ID: sampleParentArea,
        Responsable_ID: samplePst1,
      });

      sheet.addRow({
        ID: "",
        IDScire: "0102",
        Area: "DIRECCIÓN GENERAL",
        NombreAbrev: "GERENCIA",
        Tipo_Area: "DEPARTAMENTO",
        Abreviatura: "DIR",
        Gerencia_ID: samplePst2,
        Jefatura_ID: "",
        AreaJefe_ID: "",
        Responsable_ID: samplePst2,
      });

      sheet.addRow({
        ID: "",
        IDScire: "0103",
        Area: "SOPORTE TÉCNICO",
        NombreAbrev: "SOPORTE",
        Tipo_Area: "SUBAREA",
        Abreviatura: "SOP",
        Gerencia_ID: "",
        Jefatura_ID: samplePst1,
        AreaJefe_ID: sampleParentArea,
        Responsable_ID: samplePst1,
      });

      // 2. Hoja de Catálogos de Soporte (_Catalogos)
      const catSheet = workbook.addWorksheet("_Catalogos", {
        views: [{ state: "frozen", xSplit: 0, ySplit: 1 }],
      });

      catSheet.columns = [
        { header: "ID_CARGO", key: "pst_id", width: 14 },
        { header: "NOMBRE_CARGO", key: "pst_name", width: 42 },
        { header: "", key: "sep1", width: 4 },
        { header: "ID_AREA_PADRE", key: "are_id", width: 16 },
        { header: "NOMBRE_AREA", key: "are_name", width: 42 },
        { header: "", key: "sep2", width: 4 },
        { header: "ID_TIPO", key: "type_id", width: 12 },
        { header: "TIPO_AREA", key: "type_name", width: 22 },
      ];

      const catHeader = catSheet.getRow(1);
      catHeader.font = { bold: true, color: { argb: "FFFFFFFF" } };
      catHeader.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF37474F" },
      };
      catHeader.alignment = { horizontal: "center", vertical: "middle" };
      catHeader.height = 25;

      const defaultTypes = [
        { id: 1, name: "DEPARTAMENTO" },
        { id: 2, name: "AREA" },
        { id: 3, name: "SUBAREA" },
      ];

      const maxRows = Math.max(positions.length, areas.length, typeAreas.length, 3, 1);
      for (let i = 0; i < maxRows; i++) {
        const typeItem = typeAreas[i];
        const defaultType = defaultTypes[i];

        catSheet.addRow({
          pst_id: positions[i] ? positions[i].GenID : "",
          pst_name: positions[i] ? (positions[i].GenDescription || positions[i].PstName || "") : "",
          sep1: "",
          are_id: areas[i] ? areas[i].GenID : "",
          are_name: areas[i] ? (areas[i].GenDescription || areas[i].AreName || "") : "",
          sep2: "",
          type_id: typeItem ? (typeItem.DedValue || typeItem.DedID) : (defaultType ? defaultType.id : ""),
          type_name: typeItem ? (typeItem.DedDescription || "") : (defaultType ? defaultType.name : ""),
        });
      }

      // Validación de lista para Tipo_Area en columna E
      const typeLimit = Math.max(typeAreas.length + 1, 4);
      sheet.dataValidations.add("E2:E500", {
        type: "list",
        allowBlank: true,
        formulae: [`'_Catalogos'!$H$2:$H$${typeLimit}`],
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "Plantilla_Carga_Masiva_Areas.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(url);
    },
    async saveMassive(data) {
      this.isLoading = true;
      this.errors = [];
      this.progressCounter = 0;
      this.progressTotal = data.length;
      for (const item of data) {
        const newItem = {
          ...item,
          Secstatus: 1,
        };

        // Soporte tanto para ID numérico como por Nombre de cargo / área
        if (item.PstManagerID !== null && item.PstManagerID !== undefined && item.PstManagerID !== "") {
          if (isNaN(item.PstManagerID)) {
            newItem.ManagerName = item.PstManagerID.toString().trim();
            newItem.PstManagerID = null;
          } else {
            newItem.PstManagerID = parseInt(item.PstManagerID, 10);
          }
        }
        if (item.PstBossID !== null && item.PstBossID !== undefined && item.PstBossID !== "") {
          if (isNaN(item.PstBossID)) {
            newItem.BossName = item.PstBossID.toString().trim();
            newItem.PstBossID = null;
          } else {
            newItem.PstBossID = parseInt(item.PstBossID, 10);
          }
        }
        if (item.PstResponsibleID !== null && item.PstResponsibleID !== undefined && item.PstResponsibleID !== "") {
          if (isNaN(item.PstResponsibleID)) {
            newItem.ResponsibleName = item.PstResponsibleID.toString().trim();
            newItem.PstResponsibleID = null;
          } else {
            newItem.PstResponsibleID = parseInt(item.PstResponsibleID, 10);
          }
        }
        if (item.AreParentID !== null && item.AreParentID !== undefined && item.AreParentID !== "") {
          if (isNaN(item.AreParentID)) {
            newItem.AreParentName = item.AreParentID.toString().trim();
            newItem.AreParentID = null;
          } else {
            newItem.AreParentID = parseInt(item.AreParentID, 10);
          }
        }

        try {
          const response = await _sArea.saveAreaMassive(
            newItem,
            this.$fun.getUserID()
          );
          if (Array.isArray(response.data) && response.data.length > 0) {
            for (const res of response.data) {
              this.errors.push(res);
            }
          }
        } catch (error) {
          this.errors.push({
            AreName: newItem.AreName || newItem.ID,
            ErrorMsg: error?.message || error,
          });
        } finally {
          this.progressCounter++;
          this.$refs.SAreasCrud.refresh();
        }
      }
      if (this.errors.length > 0) {
        this.showErrorDialog = true;
      }
      this.isLoading = false;
      this.showOpenMasiveImport = false;
    },
  },
  created() {},
  watch: {
    "$props.item.TypeArea": function (newVal) {
      // Limpiar los campos de posición cuando cambia el tipo de área
      if (newVal === 1) {
        this.$props.item.PstBossID = null;
        this.$props.item.BossName = null;
      } else if (newVal === 2) {
        this.$props.item.PstManagerID = null;
        this.$props.item.ManagerName = null;
      }
    },
  },
};
</script>
